import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Personas de 40+ que sienten rigidez en las articulaciones al levantarse de la cama o del sofá.', 'Latinos que trabajan largas jornadas y sienten pesadez extrema en las piernas al llegar a casa.', "Quienes sufren de 'neblina mental' y fatiga que no se quita ni con 3 tazas de café.", 'Personas que notan que su ropa les queda apretada por la tarde debido a la retención de líquidos.'];
  const notForWho = ["Personas que buscan una 'pastilla mágica' para bajar de peso sin cambiar lo que ponen en su plato.", 'Quienes no están dispuestos a dejar los aceites vegetales refinados durante 10 días.', 'Atletas de alto rendimiento que ya tienen protocolos médicos de nutrición específicos.'];
  return <section className="py-20 bg-forest text-white" data-id="element-12">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-13">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-14">
          {/* Who it is for */}
          <FadeIn direction="right" data-id="element-15">
            <div className="bg-white text-forest p-8 rounded-3xl h-full shadow-xl" data-id="element-16">
              <h3 className="text-2xl font-bold mb-8 border-b border-sand pb-4" data-id="element-17">
                Este protocolo ES para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-18">
                {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-19">
                    <div className="bg-emerald/20 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-20">
                      <Check className="w-5 h-5 text-emerald-dark" data-id="element-21" />
                    </div>
                    <p className="text-gray-700 text-sm leading-relaxed" data-id="element-22">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who it is NOT for */}
          <FadeIn direction="left" delay={0.2} data-id="element-23">
            <div className="bg-forest-light/20 border border-forest-light p-8 rounded-3xl h-full" data-id="element-24">
              <h3 className="text-2xl font-bold mb-8 border-b border-forest-light pb-4 text-cream" data-id="element-25">
                Este protocolo NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-26">
                {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-27">
                    <div className="bg-red-500/20 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-28">
                      <X className="w-5 h-5 text-red-400" data-id="element-29" />
                    </div>
                    <p className="text-gray-300 text-sm leading-relaxed" data-id="element-30">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}